import ltOrderReceiptChildSummary from 'html/checkout/lt-order-receipt-child-summary.html';
import App from 'app/app.js';
import 'app/directive/LtOrderReceiptChildSummaryCtrl.js';

function LtOrderReceiptChildSummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      receiptData: '='
    },
    template: ltOrderReceiptChildSummary,
    controller: 'LtOrderReceiptChildSummaryCtrl',
    controllerAs: 'orderReceiptChildSummary'
  };
}

App.directive('ltOrderReceiptChildSummary', [LtOrderReceiptChildSummaryDirective]);
